import { InfoOutlineIcon } from '@chakra-ui/icons';
import { Flex, Tooltip } from '@chakra-ui/react';

import { Text } from '@revelio/ui';

import { DataBuilderGrid } from '../../components/ui/DataBuilderGrid';
import type { UnitOfAnalysisOption } from '../../datasets/deliverable-column-config';
import { STEP2_VALIDATION_SECTION_UNIT_OF_ANALYSIS } from '../step2-columns-validation';
import { UnitOption } from './SelectionOptions';
import { Step2SectionValidationError } from './Step2SectionValidationError';

const sectionStyles = {
  display: 'flex',
  flexDirection: 'column' as const,
  gap: '8px',
};

type UnitOfAnalysisSectionProps = {
  unitOptions: UnitOfAnalysisOption[];
  selectedUnitOfAnalysis: string | null;
  selectionDetails: Record<string, string>;
  onUnitOptionClick: (value: string) => void;
  showValidationErrors: boolean;
  sectionErrorMessage: string | undefined;
};

export const UnitOfAnalysisSection = ({
  unitOptions,
  selectedUnitOfAnalysis,
  selectionDetails,
  onUnitOptionClick,
  showValidationErrors,
  sectionErrorMessage,
}: UnitOfAnalysisSectionProps) => {
  return (
    <section style={sectionStyles} data-testid="data-builder-unit-of-analysis">
      <Flex alignItems="center" gap={1} mb={2}>
        <Text as="h3" fontSize="sm" weight="semibold">
          Unit of Analysis
        </Text>
        <Tooltip
          label="Choose the specific entities (companies, roles, geographies, etc.) you'd like to analyze"
          textAlign="center"
          hasArrow
          placement="top"
        >
          <InfoOutlineIcon boxSize={3} color="text.primary" cursor="pointer" />
        </Tooltip>
      </Flex>

      {unitOptions.length > 0 && (
        <DataBuilderGrid columns="responsive">
          {unitOptions.map((option) => (
            <UnitOption
              key={option.value}
              value={option.value}
              label={option.label}
              detail={selectionDetails[option.value]}
              description={option.description}
              isSelected={selectedUnitOfAnalysis === option.value}
              onClick={() => onUnitOptionClick(option.value)}
            />
          ))}
        </DataBuilderGrid>
      )}
      <Step2SectionValidationError
        sectionId={STEP2_VALIDATION_SECTION_UNIT_OF_ANALYSIS}
        message={sectionErrorMessage}
        show={showValidationErrors}
      />
    </section>
  );
};
